import { render } from "./ActivityListItemBoxComponent.vue?vue&type=template&id=c885f826&scoped=true"
import script from "./ActivityListItemBoxComponent.vue?vue&type=script&lang=js"
export * from "./ActivityListItemBoxComponent.vue?vue&type=script&lang=js"

import "./ActivityListItemBoxComponent.vue?vue&type=style&index=0&id=c885f826&scoped=true&lang=css"

import exportComponent from "C:\\_TimetipCode\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c885f826"]])

export default __exports__